import React, { useState } from 'react';
import type { RelanceAgendaEntry } from '../../types/customerFollowUp/relanceAgenda';
import { RelanceAgendaRow } from './RelanceAgendaRow';
import { useAppNavigate } from '../../hooks/useAppNavigate';
import { RelanceActionModal } from './RelanceActionModal';

interface RelanceAgendaProps {
    entries: RelanceAgendaEntry[];
    canCollectPayment: boolean;
    /** Shows the due date in place of the invoice count, for a list spanning several days. */
    showDates?: boolean;
    testId?: string;
}

export const RelanceAgenda: React.FC<RelanceAgendaProps> = ({ entries, canCollectPayment, showDates = false, testId = 'home-relance-agenda' }) => {
    const appNavigate = useAppNavigate();
    const [openId, setOpenId] = useState<string | null>(null);
    // Looked up on every render so the modal follows the entry when a refresh changes it, and
    // closes by itself once the relance leaves the list.
    const openEntry = entries.find(e => e.item.id === openId);

    // Today's relances open their own page; snoozed and ignored ones are acted on in a modal.
    const openEntryRow = (entry: RelanceAgendaEntry) => {
        if (entry.status === 'due') appNavigate(`${entry.routePrefix}/${entry.item.id}`);
        else setOpenId(entry.item.id);
    };

    return (
        <>
            {/* The list cannot query its own width to pick its columns, so the wrapper is the container. */}
            <div className="@container">
                <ul role="list" data-testid={testId} className="grid grid-cols-relance-agenda @relance-row:grid-cols-relance-agenda-wide gap-x-m gap-y-1.5 @relance-row:gap-y-xs">
                    {entries.map(entry => (
                        <RelanceAgendaRow key={entry.item.id} entry={entry} showDate={showDates} canCollectPayment={canCollectPayment} onOpen={() => openEntryRow(entry)} />
                    ))}
                </ul>
            </div>
            {openEntry && (
                <RelanceActionModal entry={openEntry} canCollectPayment={canCollectPayment} onClose={() => setOpenId(null)} />
            )}
        </>
    );
};
